import { useEffect, useState } from 'react';

export const useMediaQuery = (query: string) => {
    const [matches, setMatches] = useState(() =>
        typeof window === 'undefined'
            ? false
            : window.matchMedia(query).matches
    );

    useEffect(() => {
        const mediaQuery = window.matchMedia(query);
        const update = () => setMatches(mediaQuery.matches);

        update();
        mediaQuery.addEventListener?.('change', update);

        return () => mediaQuery.removeEventListener?.('change', update);
    }, [query]);

    return matches;
};
